import { useEffect, useRef, useState } from "react";
import { CATEGORY_ICONS } from "@/lib/categoryIcons";

const TONES = { card: { M: "#0B2E44", W: "#FFFFFF", C: "#C8432C" }, light: { M: "#0B2E44", W: "#8FC3CF", C: "#F08DB5" } };

// Bauhaus/Swiss-style category symbol; the single coral element drifts slowly while on screen.
export const CategoryIcon = ({ k, tone = "card", className = "", testId }) => {
  const ref = useRef(null);
  const [on, setOn] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || !("IntersectionObserver" in window)) return undefined;
    const io = new IntersectionObserver(([e]) => setOn(e.isIntersecting));
    io.observe(el);
    return () => io.disconnect();
  }, []);
  const svg = CATEGORY_ICONS[k];
  if (!svg) return null;
  const c = TONES[tone];
  const html = `<svg viewBox="0 0 48 48" fill="none" stroke-linecap="round" stroke-linejoin="round" width="100%" height="100%" aria-hidden="true">${svg.replace(/\{M\}/g, c.M).replace(/\{W\}/g, c.W).replace(/\{C\}/g, c.C)}</svg>`;
  return <span ref={ref} data-testid={testId || `category-icon-${k}`} data-anim={on ? "running" : "paused"} className={`category-icon block ${className}`} dangerouslySetInnerHTML={{ __html: html }} />;
};
